import type { AskRequest } from '@hone-automation/common';

type ActionVisibilityOptions = {
  canManageQueue?: boolean;
  isBookkeeperAdmin?: boolean;
};

type ActionVisibility = {
  isClosed: boolean;
  showDueDate: boolean;
  showResolve: boolean;
  showRecategorize: boolean;
  showBlockerToggle: boolean;
  showReopen: boolean;
};

export const getRequestActionVisibility = (
  request: AskRequest,
  { canManageQueue = false, isBookkeeperAdmin = false }: ActionVisibilityOptions = {}
): ActionVisibility => {
  const isClosed = request.status === 'Closed';
  const showDueDate = !isClosed;
  const showResolve = !isClosed;
  const showRecategorize = Boolean(
    isBookkeeperAdmin && request.transaction?.id && !isClosed && request.canRecategorize
  );
  const showBlockerToggle = Boolean(canManageQueue && !isClosed);
  const showReopen = Boolean(canManageQueue && isClosed && request.canReopen);

  return {
    isClosed,
    showDueDate,
    showResolve,
    showRecategorize,
    showBlockerToggle,
    showReopen,
  };
};
